import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class CustomBookingAttributeRepositoryService extends BaseRepositoryService<
  ModelRegistry['custom-booking-attribute']
> {
  recordName = 'custom-booking-attribute';
  implementMethods = ['findAll', 'peekAll'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/custom-booking-attribute': CustomBookingAttributeRepositoryService;
  }
}
